import { render } from "./managementPanel.vue?vue&type=template&id=96cfe9fa&scoped=true"
import script from "./managementPanel.vue?vue&type=script&lang=js"
export * from "./managementPanel.vue?vue&type=script&lang=js"

import "./managementPanel.vue?vue&type=style&index=0&id=96cfe9fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96cfe9fa"]])

export default __exports__